var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifiSettingsEmpyStatusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#o8btt48jya)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.778 20.219H37.334a3.11 3.11 0 0 0-3.111 3.11v23.334a3.111 3.111 0 0 0 3.11 3.111h12.445a3.111 3.111 0 0 0 3.111-3.11V23.33a3.111 3.111 0 0 0-3.11-3.111zm0 3.11v17.112H37.334V23.33h12.444zM37.334 46.664V42.93h12.444v3.733H37.334z",
    fill: "url(#eccpf10tlb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.11 34.219H6.22V9.329h37.334v7.779h3.11V9.33a3.11 3.11 0 0 0-3.11-3.111H6.22a3.111 3.111 0 0 0-3.11 3.11v24.89a3.11 3.11 0 0 0 3.11 3.11h24.89v-3.11z",
    fill: "url(#r521ecpomc)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.112 40.445H14.001a1.556 1.556 0 1 0 0 3.111h17.111v-3.11z",
    fill: "url(#8x7du2k7sd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.444 18.852v-8.82H5.52v25.874h25.572V20.852a2 2 0 0 1 2-2h7.352z",
    fill: "url(#z8dt8ibb7e)",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eccpf10tlb",
    x1: 34.223,
    y1: 37.406,
    x2: 53.884,
    y2: 33.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r521ecpomc",
    x1: 3.109,
    y1: 24.31,
    x2: 42.672,
    y2: 6.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "8x7du2k7sd",
    x1: 12.445,
    y1: 42.255,
    x2: 16.684,
    y2: 33.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z8dt8ibb7e",
    x1: 5.52,
    y1: 24.469,
    x2: 37.19,
    y2: 9.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A6CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "o8btt48jya"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiSettingsEmpyStatusIcon);
export default __webpack_public_path__ + "static/media/wifiSettingsEmpyStatusIcon.00cfdc15f2c7e699fa92458eee0cec26.svg";
export { ForwardRef as ReactComponent };